import React from 'react';
import './style.css';

const DescItem = ({
	imgSrc, title, desc
                  }) => {
	
	return (
		<div className='flex gap-4 py-2'>
			<img className='w-[67px] h-[45px]' src={imgSrc} alt="imgSrc"/>
			<div className=''>
				<div className='font-bold text-base'>{title}</div>
				<div className='text-xs'>{desc}</div>
			</div>
		</div>
	);
}

export default DescItem;
